var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.28592 12.0007C4.23252 12.0007 5.98268 11.2819 7.23279 10.1412C8.30431 13.5164 11.8046 16.0009 16.005 16.0009C21.059 16.0009 25.0844 12.4226 25.0844 8.00047C25.0844 3.57833 20.9947 0 16.005 0C12.4061 0 9.31655 1.83636 7.8257 4.48464C6.57916 2.98455 4.57184 2.00012 2.28592 2.00012C2.28592 4.08586 3.50888 5.92222 5.36691 7.00041C3.5096 8.08172 2.28592 9.91308 2.28592 12.0007ZM12.5726 6.00035H19.366C20.6947 6.00035 21.7162 6.89415 21.7162 8.00047H10.2866C10.2866 6.89415 11.3082 6.00035 12.5726 6.00035ZM21.8448 19.1824L16.0014 26.0015L10.158 19.1824C4.38325 20.1012 0 24.5139 0 29.833C0 31.0293 1.10867 32 2.47594 32H29.5241C30.8913 32 32 31.0299 32 29.833C32.0029 24.5139 27.6167 20.1012 21.8448 19.1824Z",
    fill: "#343434"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIco);
export default __webpack_public_path__ + "static/media/user_ico.c5252498bd87195f55820aac3ee433be.svg";
export { ForwardRef as ReactComponent };